
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"56","height":"67"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"fill":"#F4CB00","d":"M28 0L0 16.75v33.5L28 67l28-16.75v-33.5L28 0z"}}),_c('path',{attrs:{"fill":"#FFF","d":"M26.025 35.63L15 19h5.06L28 31.738 36.187 19H41L29.975 35.63V48h-3.95z"}})])])
          )
        }
      }
    